import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

const categoryIcons: Record<string, string> = {
  '全部': 'ri-apps-line',
  '电视剧': 'ri-tv-2-line',
  '电影': 'ri-movie-2-line',
  '综艺': 'ri-emotion-laugh-line',
  '动漫': 'ri-ghost-line',
  '纪录片': 'ri-earth-line',
  '短视频': 'ri-vidicon-line',
  '体育': 'ri-football-line',
  '音乐': 'ri-music-2-line',
  '游戏': 'ri-gamepad-line',
};

const categorySlugs: Record<string, string> = {
  '全部': 'all',
  '电视剧': 'dianshiju',
  '电影': 'dianying',
  '综艺': 'zongyi',
  '动漫': 'dongman',
  '纪录片': 'jilupian',
  '短视频': 'duanshipin',
  '体育': 'tiyu',
  '音乐': 'yinyue',
  '游戏': 'youxi',
};

export default function CategoryGrid() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500">按分类探索您感兴趣的内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
          {categories.filter(c => c !== '全部').map((category) => (
            <Link
              key={category}
              to={`/category/${categorySlugs[category]}`}
              className="group flex flex-col items-center gap-3 p-6 bg-background-50 rounded-xl cursor-pointer transition-all duration-300 hover:scale-105 hover:bg-primary-50"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${categoryIcons[category] || 'ri-folder-line'} text-2xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-foreground-900 transition-colors whitespace-nowrap">
                {category}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}